var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPlus = function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#plus_svg__a)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M30.952 33.333a3.81 3.81 0 0 0 3.81-3.81v-7.618L36.667 20l-1.905-1.905v-7.618a3.809 3.809 0 0 0-3.81-3.81m-21.903 0a3.809 3.809 0 0 0-3.81 3.81v7.618L3.334 20l1.905 1.905v7.618a3.809 3.809 0 0 0 3.81 3.81m10.952-20v13.333M13.334 20h13.333"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "plus_svg__a",
    x1: 33.71,
    x2: -28.438,
    y1: 7.403,
    y2: 37.145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D92E7F"
  })))));
};
export default SvgPlus;